import Heading from '@components/Heading/Heading';
import SingleDesigner from '@features/cms/components/collections/DesignersBlock/SingleDesigner';
import styles from '@features/cms/components/collections/DesignersBlock/DesignersBlock.styles';
import { TImage } from '@components/typescript';
type PropsType = {
  title: string;
  image: TImage;
  description: string;
  buttonText: string;
  setIsModalOpen: (isOpen: boolean) => void;
  name: string;
  isFirst: boolean;
  email: string;
  phone: string;
};
const Designer = ({
  title,
  image,
  description,
  buttonText,
  setIsModalOpen,
  name,
  isFirst,
  email,
  phone
}: PropsType) => <>
    <SingleDesigner title={title} image={image} description={description} buttonText={buttonText} setIsModalOpen={setIsModalOpen} fullContent isFirst={isFirst} email={email} phone={phone} />
    <span sx={styles.designerNameText}>
      <Heading h={4} headingType={4}>
        {name}
      </Heading>
    </span>
  </>;
export default Designer;